export const statusOptions = [
	{ key: 'active', label: 'Actif' },
	{ key: 'inactive', label: 'Inactif' },
	{ key: 'suspended', label: 'Suspendu' },
];

export const roleOptions = [
	{ key: 'ROLE_ADMIN', label: 'Administrateur' },
	{ key: 'ROLE_USER', label: 'Utilisateur' },
];

/*
{ key: 'ROLE_SALES', label: 'Commercial' },
{ key: 'ROLE_BUYER', label: 'Commercial/Acheteur' },
{ key: 'ROLE_MANAGER', label: 'Gestionnaire' },
{ key: 'ROLE_CUSTOM', label: 'Personnalisé' },
*/

// User interface definition
export interface UserPermission {
	id?: number;
	module: { id?: string; name?: string; title?: string };
	action: 'read' | 'write' | 'delete' | 'execute';
}

export interface UserData {
	id: number;
	login?: string;
	password?: string;
	email?: string;
	name?: string;
	firstName?: string;
	status?: 'active' | 'inactive' | 'suspended';
	roles?: string[];
	permissions?: UserPermission[];
}
